export default __webpack_public_path__ + "alberta-series-article.47628c2ecccbbc4202b6.svg";